import { Platform } from 'src/environment';
import { asyncLoadLibrary } from 'src/shared/utilities/asyncLoadLibrary';
import {
  handleExecuteNativeFetch,
  getAuthToken,
} from 'src/utilities/network-utility';

export async function loadClickstream(): Promise<void> {
  if (window.ghsConfiguration.platform === Platform.WEB) {
    initializeClickstreamQueue();
    await asyncLoadLibrary({
      id: 'clickstreamJS',
      url: 'https://assets.grubhub.com/libs/clickstreamjs/2.0.21/clickstream2.min.js',
      attributes: { async: '' },
      isAppend: false,
    });
  }
}

function initializeClickstreamQueue(): void {
  const csq: ClickstreamQueue = (window._csq =
    window._csq || ([] as ClickstreamQueue));

  if (!csq.platform) {
    csq.platform = `umami ${window.ghsConfiguration.brand.toLowerCase()}`;
    csq.host = 'https://clickstream.grubhub.com';
    csq.userIdKey = 'clickstream-analytics-user-id';
    csq.userUdidKey = 'analytics-user-id';
    csq.v2platform = {
      app: window.ghsConfiguration.clickstreamApp,
      appVersion: window.ghsConfiguration.clickstreamAppVersion,
      env:
        window.ghsConfiguration.environment === 'production'
          ? 'prod'
          : 'preprod',
      brand: window.ghsConfiguration.brand.toLowerCase(),
    };
    csq.v2host = window.ghsConfiguration.clickstreamV2PostUrl;
    csq.isSequenceStored = true;
    csq.v2post = getConfiguredV2Post();
  }
}

function getConfiguredV2Post(): (
  url: string,
  data: { events: ClickstreamEventsPayload[] },
) => Promise<any> {
  const clickstreamLog: ClickstreamLog = {
    input: [],
    output: [],
  };

  return (
    url: string,
    data: { events: ClickstreamEventsPayload[] },
  ): Promise<any> => {
    const payload = data.events[0];

    if (!window.__cslog) {
      window.__cslog = clickstreamLog;
    }

    clickstreamLog.input.push(
      [
        'CSLOG',
        payload.data.moduleName || payload.data.pageName,
        payload.event.name,
      ].join(' '),
    );

    const config = window.ghsConfiguration;
    const authToken = getAuthToken();

    // Use handleExecuteNativeFetch for authenticated requests
    return handleExecuteNativeFetch({
      httpServiceData: {
        apiUrl: config.jjApiUrl,
        authToken,
        brand: config.brand,
        clientId: config.clientId,
      },
      method: 'POST',
      url,
      data: JSON.parse(JSON.stringify(data)),
    });
  };
}
